import { useState } from "react";
import api, { apiErr, API } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export const isIdDoc = (key) => /^(id_|cc_conjuge_|cc_herdeiros)/.test(key);

export function DocImage({ doc }) {
  if (!doc.file_id) return null;
  return (
    <a href={`${API}/files/${doc.file_id}`} target="_blank" rel="noreferrer" className="block shrink-0 md:w-56" data-testid={`ai-image-${doc.key}`}>
      <img src={`${API}/files/${doc.file_id}/preview`} alt={doc.name} className="w-full rounded-lg border border-slate-200 bg-white object-contain max-h-72" />
    </a>
  );
}

const toPt = (v) => (/^\d{4}-\d{2}-\d{2}$/.test(String(v)) ? String(v).split("-").reverse().join("/") : v ?? "");
const toIso = (v) => (/^\d{2}\/\d{2}\/\d{4}$/.test(String(v)) ? String(v).split("/").reverse().join("-") : v);

export function AiCorrect({ pid, doc, onDone, onCancel }) {
  const fields = (doc.ai?.fields || []).filter((f) => !String(f.key).startsWith("_"));
  const [v, setV] = useState(Object.fromEntries(fields.map((f) => [f.key, toPt(f.value)])));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/processes/${pid}/documents/${doc.key}/ai-fields`, { values: Object.fromEntries(Object.entries(v).map(([k, x]) => [k, toIso(x)])) });
      toast.success(data.changed?.length ? `Corrigido: ${data.changed.join(", ")}` : "Confirmado sem alterações");
      onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 flex flex-col md:flex-row gap-3" data-testid={`ai-correct-${doc.key}`}>
      <DocImage doc={doc} />
      <div className="flex-1 space-y-1.5">
        {fields.map((f) => (
          <label key={f.key} className="grid grid-cols-[9rem_1fr] items-center gap-2 text-xs">
            <span className="text-slate-500 truncate">{f.label || f.key.replace(/_/g, " ")}</span>
            <Input value={v[f.key]} onChange={(e) => setV({ ...v, [f.key]: e.target.value })} className="h-8 text-sm" data-testid={`ai-correct-input-${f.key}`} />
          </label>
        ))}
        <div className="flex justify-end gap-2 pt-1">
          <button onClick={onCancel} className="px-3 py-1.5 text-xs text-slate-600" data-testid={`ai-correct-cancel-${doc.key}`}>Cancelar</button>
          <button onClick={save} disabled={busy} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-ec-green text-white disabled:opacity-50" data-testid={`ai-correct-save-${doc.key}`}>
            {busy && <Loader2 size={12} className="animate-spin" />}Guardar correção</button>
        </div>
      </div>
    </div>
  );
}
